import { Card, CardBody, Col } from "reactstrap";
import { H6, LI, P, UL } from "../../../../../AbstractElements";
import { TrendingPostsData } from "../../../../../Data/Miscellaneous/Blog";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const TrendingPosts = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title="Trending Posts" headClass="pb-0 border-0" />
        <CardBody>
          <UL className="recent-blog trending-blog simple-list">
            {TrendingPostsData.map((item, indxe) => (
              <LI key={indxe}>
                <div className="d-flex gap-2 align-items-start">
                  <H6>{item.id}.</H6>
                  <div className="flex-grow-1">
                    <H6>{item.title}</H6>
                    <P>{item.date}</P>
                  </div>
                </div>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TrendingPosts;
